import { useEffect, useState } from "react";

export const ValidationTracker = ({
  isValid,
  onValidationChange
}: {
  isValid: boolean;
  onValidationChange: (isValid: boolean) => void;
}) => {
  const [lastValidState, setLastValidState] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (lastValidState !== isValid) {
      setLastValidState(isValid);
      onValidationChange(isValid);
    }
  }, [isValid, lastValidState, onValidationChange]);

  return null;
};
